export const CK_EDITOR_CONFIG = {
  toolbar: [
    "heading",
    "bold",
    "italic",
    "link",
    "undo",
    "redo",
    "numberedList",
    "bulletedList",
    "todoList",
    "insertTable",
    "insertImage"
  ],
  placeholder: "Please Enter...",
  table: {
    contentToolbar: [
      "tableColumn",
      "tableRow",
      "mergeTableCells",
      "tableProperties",
      "tableCellProperties"
    ]
  },
  heading: {
    options: [
      {
        model: "heading2",
        view: {
          name: "h2",
          classes: "abi-h2"
        },
        title: "Heading 2",
        converterPriority: "high"
      },
      {
        model: "heading2(seo-h4)",
        view: {
          name: "h2",
          classes: "abi-h4"
        },
        title: "Heading 2 (SEO-H4)",
        converterPriority: "high"
      },
      {
        model: "heading3",
        view: {
          name: "h3",
          classes: "abi-h3"
        },
        title: "Heading 3",
        converterPriority: "high"
      },
      {
        model: "heading3(seo-h5)",
        view: {
          name: "h3",
          classes: "abi-h5"
        },
        title: "Heading 3 (SEO-H5)",
        converterPriority: "high"
      },
      {
        model: "heading4",
        view: {
          name: "h4",
          classes: "abi-h4"
        },
        title: "Heading 4",
        converterPriority: "high"
      },
      {
        model: "heading5",
        view: {
          name: "h5",
          classes: "abi-h5"
        },
        title: "Heading 5",
        converterPriority: "high"
      },
      {
        model: "p",
        view: {
          name: "p",
          classes: "p_lg"
        },
        title: "Paragraph Large",
        converterPriority: "high"
      },
      {
        model: "paragraph2",
        view: {
          name: "p",
          classes: "p_base"
        },
        title: "Paragraph Base",
        converterPriority: "high"
      },
      {
        model: "paragraph3",
        view: {
          name: "p",
          classes: "p_sm"
        },
        title: "Paragraph Small",
        converterPriority: "high"
      },
      {
        model: "paragraph4",
        view: {
          name: "p",
          classes: "p_xs"
        },
        title: "Paragraph XSmall",
        converterPriority: "high"
      },
      {
        model: "paragraph5",
        view: {
          name: "p",
          classes: "p_xxs"
        },
        title: "Paragraph XXSmall",
        converterPriority: "high"
      }
    ]
  }
};
